/**
 * Limited capacity stack where the stack will drop the oldest item (bottom of the stack) when size limit is reached.
 */
export default class SlidingStack<T> {
  maxSize: number;
  items: T[];
  constructor(maxSize = 50) {
    this.maxSize = maxSize > 1 ? maxSize : 50;
    this.items = [];
  }

  private _maybeDropItems(): void {
    while (this.items.length >= this.maxSize) {
      this.items.shift();
    }
  }

  get size(): number {
    return this.items.length;
  }

  /**
   * Push an item to the top of the stack.
   */
  push(item: T): void {
    this._maybeDropItems();
    this.items.push(item);
  }

  /**
   * Pop an item off the top of the stack and return it.
   * @returns the item or undefined if none exist.
   */
  pop(): T | undefined {
    return this.items.pop();
  }

  /**
   * Peek at the item on the top of the stack.
   * @returns the item or undefined if none exist.
   */
  peek(): T | undefined {
    return this.items[this.items.length - 1];
  }
}
